module.exports = __webpack_public_path__ + "img/1519067006.455d2724.jpg";